import { Avatar, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useListComments } from '@/features/crm/api/listCommentsByCard.ts';
import { CommentModel } from '@/features/crm/types';
import DateHelper from '@/utils/DateHelper.ts';
import DateFormat from '@/utils/DateFormat.ts';

type ListCommentsProps = {
  cardId: number;
}

const ListComments: React.FC<ListCommentsProps> = ({ cardId }) => {
  const { data: comments = [] } = useListComments(cardId);
  return (
    <>
      {
        comments.map((comment: CommentModel) => (
          <Stack sx={{ p: '20px 30px 0px 30px' }} flexDirection={'row'}>
            <Avatar src={comment.usuario?.avatar}>
              {comment.usuario.username.charAt(0)}
            </Avatar>
            <Stack flexDirection={'column'} ml={1}>
              <Typography>
                {' '}
                <Typography fontWeight={"bold"} textTransform={"capitalize"}>{comment.usuario.username}</Typography>
                <div className="content" dangerouslySetInnerHTML={{ __html: comment.texto }}></div>
              </Typography>
              <Typography>
                {DateFormat.datetime(comment.created_at)}
              </Typography>
            </Stack>
          </Stack>
        ))
      }
    </>
  );
};

export default ListComments;